import axios from "axios";

import { range } from "@/utils";
import { normalizeText } from "@/utils/index";
import { format, parse } from "date-fns/esm";

export interface CodeMatch {
  id: string;
  type: string;
  description: string;
  dates: string[];
  positions: number[];
}

interface MatchItem {
  selected: boolean;
  type: "match";
  match: CodeMatch;
}

interface CustomItem {
  selected: boolean;
  type: "custom";
  name: string;
  date: string;
}

export type Item = MatchItem | CustomItem;

export interface EncodeResults {
  items: Item[];
  meta: Record<string, any>;
}

interface RawEvidence {
  code: string;
  codename: string;
  codetype: string;
  tokspans: any[];
  refers: Record<"dates", []>;
}

export const encodeText = (text: string, endpoint: string, headers: any) => {
  const normalized = normalizeText(text);

  return axios.post(endpoint, normalized, { headers }).then(response => ({
    time: response.data.computetime,
    meta: {
      date: response.data.icd.docmeta.docdate
        ? format(
            parse(response.data.icd.docmeta.docdate, "y-M-d", new Date()),
            "M/d/y"
          )
        : null,
      patient: response.data.icd.docmeta.patname
    },
    items: response.data.icd.imatches
      .filter((match: any) => Object.keys(match).length)
      .map((evidence: RawEvidence) => ({
        selected: false,
        type: "match",
        match: {
          id: evidence.code,
          type: evidence.codetype,
          description: evidence.codename,
          dates: evidence.refers.dates
            .filter(Boolean)
            .filter(date => /[0-9]{1,2}-[0-9]{1,2}-[0-9]{1,4}/.test(date))
            .map(date => format(parse(date, "y-M-d", new Date()), "M/d/y")),
          positions: evidence.tokspans
            .filter(position => position.length)
            .map((position: [number, number]) => range(...position))
            .flat(1)
        }
      }))
  }));
};
